import React from 'react';
import Rollbar from '../../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';

class Register extends React.Component {
  state = {
    email: '',
    password: '',
    phone: '',
    name: '',
    address: ''
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value})
  }

  signUp() {
    axios.post('/auth/register', {
        email: this.state.email,
        password: this.state.password,
        phone: this.state.phone,
        name: this.state.name,
        address: this.state.address
      })
      .then(data => {
        this.props.showLogin()
      })
      .catch(err => {
        console.error(err)
        Rollbar.error(err)
        toast.error('Unable to register new account')
      })
  }

  render() {
    return (
      <div className="text-center">
        <form className="form-signin" onSubmit={e => e.preventDefault()}>
          <img className="mb-4" src="/logo.png" alt="" width="300" />
          <h1 className="h3 mb-3 font-weight-normal">Register</h1>
          <label for="inputEmail" className="sr-only">Email address</label>
          <input type="email" id="inputEmail" className="form-control input1" placeholder="Email address" name="email" value={this.state.email} onChange={this.handleChange.bind(this)} />
          <label for="inputPassword" className="sr-only">Password</label>
          <input type="password" id="inputPassword" className="form-control input3" placeholder="Password" name="password" value={this.state.password} onChange={this.handleChange.bind(this)} />
          <label for="inputPhone" className="sr-only">Company Phone</label>
          <input type="text" id="inputPhone" className="form-control input3" placeholder="Phone" name="phone" value={this.state.phone} onChange={this.handleChange.bind(this)} />
          <label for="inputName" className="sr-only">Company Name</label>
          <input type="text" id="inputName" className="form-control input3" placeholder="Name" name="name" value={this.state.name} onChange={this.handleChange.bind(this)} />
          <label for="inputAddress" className="sr-only">Company Address</label>
          <input type="text" id="inputAddress" className="form-control input2" placeholder="Address" name="address" value={this.state.address} onChange={this.handleChange.bind(this)} />
          <button className={this.state.email && this.state.password && this.state.phone && this.state.name && this.state.address ? "btn btn-lg btn-primary btn-block" : "btn btn-lg btn-primary btn-block disabled"} type="submit" onClick={this.signUp.bind(this)}>Register</button>
          <p className="mt-3 mb-1">Already have an account? <a href="#fix" onClick={this.props.showLogin}>Sign in</a></p>
          <p className="mt-3 mb-3 text-muted">&copy; {new Date().getFullYear()} OrderFresh</p>
        </form>
      </div>
    )
  }
}

export default Register;
